/* eslint-disable no-unused-vars */
import _ from 'lodash'
import { CancelToken } from 'axios'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function fetchBrands(options = {}) {
  const { page = 1, ...others } = options
  const params = options
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchBrands',
    () => source.cancel('fetchBrands: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: 'brands',
      method: 'get',
      params,
      cancelToken: source.token,
      arrayFormat: 'brackets'
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ cacheChecksum, data }) => ({
      brands: data.brands,
      next: _.get(data, 'brandsPagination.nextPage') > page
        ? () => fetchBrands({
          page: page + 1,
          ...others
        })
        : null,
      all: page === 1 && _.get(data, 'brandsPagination.nextPage') > 1
        ? () => Promise.all(
          _.times(
            _.get(data, 'brandsPagination.totalPages') - 1,
            (index) => fetchBrands({
              pageCountless: true,
              page: index + 2,
              ...others
            }),
          ),
        )
        : null,
      count: _.get(data, 'brandsPagination.totalCount'),
      cacheChecksum: _.get(cacheChecksum, 'brandsValue')
    }))
};
